import { FormikDropdown } from '../../../../components/form-components/common-components/dropdown/FormikDropdown';
import { FormikTextField } from '../../../../components/form-components/common-components/text-field/FormikTextField';
import { formatPhoneMask } from './personFormUtils';
import { personFieldIcons as PI } from './personFieldIcons';
import styles from './PersonForm.module.css';

type PersonFormFieldsProps = {
  hospitalOptions: Array<{ value: number; label: string }>;
};

const PersonFormFields = ({ hospitalOptions }: PersonFormFieldsProps) => {
  return (
    <>
      <div className={styles.inputContainer}>
        <FormikTextField
          name="name"
          label="İsim"
          placeholder="İsim giriniz"
          startIcon={PI.name}
          required
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikDropdown
          name="hospitalId"
          options={hospitalOptions}
          label="Hastane"
          placeholder="Hastane seçiniz"
          startIcon={PI.hospital}
          required
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikTextField
          name="phoneNumber"
          label="Telefon Numarası"
          placeholder="(5XX) XXX XX XX"
          type="tel"
          startIcon={PI.phoneNumber}
          mask={formatPhoneMask}
          required
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikTextField
          name="email"
          label="E-mail"
          placeholder="E-mail giriniz (opsiyonel)"
          type="email"
          startIcon={PI.email}
        />
      </div>
    </>
  );
};

export default PersonFormFields;
